import { render } from "./PatientsDatatableTDF043.vue?vue&type=template&id=8d139738"
import script from "./PatientsDatatableTDF043.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDF043.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__